const topics = [
  {
    title: "Photosynthesis",
    slug: "photosynthesis",
    standardNumber: "4.2",
    description: "Living Systems and Processes – Photosynthesis is how plants make food using sunlight, water, carbon dioxide, and chlorophyll while releasing oxygen into the air.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fphotosynthesis2025video.mp4?alt=media&token=f1dd2985-8798-48a4-bac0-e8e9ad8cd07d",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fphotosynthesis2025song.mp3?alt=media&token=4c2bbcca-ccbe-4515-be6f-8604eb8bb65e",
    lyrics: ["(Chorus)",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",

"(Verse)",
"Energy coming from the sunlight, is what we need to get this started.",
"Water gathered by the roots right, is what we need to get this started.",
"Carbon dioxide from the air, is what we need to get this started.",
"Chlorophyll in the cells of green plants, is what we need to get this started.",
"The chlorophyll takes in the light from the sun.",
"The sun's energy splits the water into hydrogen and oxygen.",
"The hydrogen mixes with the carbon dioxide to make the food, yeah,",
"and the food is carried throughout the plant while the oxygen goes into the air.",

"(Chorus)",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",
"Photosynthesis is the process of how plants make food.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Eco Energy Flow",
    slug: "ecoenergyflow",
    standardNumber: "4.2",
    description: "Living Systems and Processes – Energy flows in an ecosystem from the sun to plants to animals, with less energy available at each level of the food chain.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fecoenergyflowvideo2025.mp4?alt=media&token=0ce82f97-1cc3-4b57-a896-f06c69a7c480",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fecoenergyflow.mp3?alt=media&token=5bb7ea35-25d2-4ac5-9e05-bc513ff8cfe7",
    lyrics: ["Eco Energy Flow",

"Energy starts from the sun, to the producer, a.k.a. the plant.",

"(verse)",
"Now, green plants use photosynthesis to make their food",
"and during their life most of the energy they use.",
"A small percentage of their energy is used for heat.",
"A smaller percentage goes to that little animal that comes through and eat it.",
"Now, that little animal that ate the plant,",
"he gives off even less energy for heat.",
"And that big animal that eats the little animal,",
"he gets a much smaller percent of energy.",
"The moral of the energy flow is,",
"to get the energy you need,",
"animals at the top of the food chain",
"need more food to meet their needs.",

"(chorus)",
"Energy flow.",
"Watch me spit it.",
"Energy flow.",
"In the ecosystem.",
"Energy flow.",
"For sure, I did it!",
"Energy flow.",
"In the ecosystem.",
"Energy flow.",
"Come get with it.",
"Energy flow.",
"In the ecosystem.",
"Energy flow.",
"Come get with it.",
"Energy flow.",
"In the ecosystem.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Animal Life Cycle",
    slug: "animallifecycle",
    standardNumber: "4.2",
    description: "Living Systems and Processes – All animals share a life cycle of being born, developing, reproducing, and aging, with humans growing from babies to children, teenagers, and adults.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimallifecycle2025song%20.mp3?alt=media&token=666e6c14-f00a-4379-95cc-3047adb2ac18",
    lyrics: ["(Chorus)",
"Born, developing, reproducing.",
"Life cycle of animals.",
"Born, developing, reproducing.",
"Life cycle of animals.",

"(Verse)",
"Now, all animal life cycles are the same in some ways.",
"We’re all born, we develop, we reproduce, then the cycle starts over again.",
"Humans start reproducing from an egg inside a mother's body,",
"For 9 months then they’re born, learning for 3 years as babies.",
"Then we grow into children, taller, smarter, more independent.",
"Around the ages 13 to 18, we’re teenagers, adolescents.",
"After that, we become adults until we are old and grey.",
"Start a family, when we reproduce the life cycle starts over again.",

"(Chorus)",
"Born, developing, reproducing.",
"Life cycle of animals.",
"Born, developing, reproducing.",
"Life cycle of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Plant Life Cycle",
    slug: "plantlifecycle",
    standardNumber: "4.2",
    description: "Living Systems and Processes – The plant life cycle begins with a seed and moves through germination, sprout, seedling, adult plant, and reproduction through flowers or spores.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantlifecycle.mp4?alt=media&token=04c5304e-ef30-4fec-b739-882b2fd418ab",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantlifecycle.mp3?alt=media&token=20abb63d-b1eb-4ab8-b653-4bd0e6bffc81",
    lyrics: ["(chorus)",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",

"(verse)",
"Now, all plant seeds have an outer cover called a seed coat,",
"to protect the plant inside the seed called the embryo.",
"When the seed germinates, the root bust out then start growing down.",
"Then the seed germinates, the shoot bust out, grows up above the ground.",
"Now it’s a sprout right there.",
"With help from the water, soil, sun, and air,",
"the plant becomes a seedling.",
"A small plant with a few leaves.,",
"The next stage is a young adult plant.",
"Over time it becomes a full adult plant.",
"Then you’ll see the flowers or spores,",
"used to reproduce and make more,",
"and make more,",
"through pollination.,",

"(chorus)",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",
"Plant life cycle, oh-wo-wo- oh -wo-wo.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Ecosystem Levels",
    slug: "ecosystemlevels",
    standardNumber: "4.3",
    description: "Living Systems and Processes – Ecosystems are organized into levels starting with organisms, then populations, communities, and finally the whole ecosystem including living and nonliving things.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fecosystemlevels2025video.mp4?alt=media&token=d28fd355-34df-4108-aa08-aab6454be863",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fecosystemlevels2025song.mp3?alt=media&token=936d0836-5ca7-4b69-bb1c-04b8c39d689b",
    lyrics: ["(chorus)",
"There's levels or organization in every ecosystem.",
"There's levels or organization in every ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",

"(verse)",
"Let's start with a single organism and call it level one.",
"When that organism reproduce, and they reproduce, population has begun.",
"Now, organisms interact with different organisms, it's a community.",
"To make it an ecosystem, add the living things with the non-living things.",

"(chorus)",
"There's levels or organization in every ecosystem.",
"There's levels or organization in every ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",
"You’ve got the organism, you’ve got the population, got the community, got the ecosystem.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Food Chain",
    slug: "foodchain",
    standardNumber: "4.3",
    description: "Living Systems and Processes – A food chain shows how energy moves in an environment from producers like grass to consumers such as grasshoppers, frogs, snakes, and hawks.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffoodchain2025video.mp4?alt=media&token=9b71ff42-697f-4de2-8adf-573beac0d90a",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffoodchain2025song.mp3?alt=media&token=6800dd25-d5a1-43fe-b181-913ce4501b09",
    lyrics: ["(chorus)",
"Grass is eaten by a grasshopper, who is eaten by a frog,",
"who is eaten by a snake, who is eaten by a hawk.",
"That’s how the food chain works.",
"Right down the line that’s how the food chain works.",

"(verse)",
"A food chain explains how food energy goes between living things",
"in an environment, in an environment.",
"Producers are at the bottom of the food chain.",
"Consumers go to the top of the food chain",
"by eating living things in an environment.",

"(chorus)",
"Grass is eaten by a grasshopper, who is eaten by a frog,",
"who is eaten by a snake, who is eaten by a hawk.",
"That’s how the food chain works.",
"Right down the line that’s how the food chain works.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Food Web",
    slug: "foodweb",
    standardNumber: "4.3",
    description: "Living Systems and Processes – A food web shows how plants and animals are connected through many feeding paths, keeping nature in balance and depending on each other for survival.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffoodweb2025video.mp4?alt=media&token=1c7eae0b-5548-486a-8a71-7af001a21cb5",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffoodweb2025song.mp3?alt=media&token=d9108a4b-545b-4ce0-ac4f-f96ce831ccd2",
    lyrics: ["(Chorus)",
"In a food web, we see how plants and animals connect.",
"In a food web, we see how plants and animals connect,",
"Through many paths, through many paths.",
"A food chain shows just one way to go,",
"But a food web shows how life can grow.",

"(Verse 1)",
"Trees make acorns, food for bugs and mice.",
"When the mice are here, snakes and owls think it’s nice.",
"Bugs are food for birds, and skunks eat them too.",
"Every animal matters, they all have jobs to do.",
"If one animal goes, the others feel the loss.",
"Like a broken web, it comes at a big cost.",

"(Chorus)",
"In a food web, we see how plants and animals connect.",
"In a food web, we see how plants and animals connect,",
"Through many paths, through many paths.",
"A food chain shows just one way to go,",
"But a food web shows how life can grow.",

"(Verse 2)",
"Plants give food to animals, animals help them grow.",
"If one part disappears, it’s hard for others, you know.",
"Foxes eat the rabbits, rabbits eat the grass.",
"Everything works together so nature can last.",
"The food web is a circle, a balance we must keep.",
"Protecting every animal and the places where they sleep.",

"(Chorus)",
"In a food web, we see how plants and animals connect.",
"In a food web, we see how plants and animals connect,",
"Through many paths, through many paths.",
"A food chain shows just one way to go,",
"But a food web shows how life can grow.",

"(Outro)",
"So let’s take care of nature, the plants, the animals too.",
"The food web keeps them living, and it helps us all too!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Determine Weather",
    slug: "determineweather",
    standardNumber: "4.4",
    description: "Earth and Space Systems – Weather is determined by conditions like temperature, precipitation, wind direction and speed, air pressure, and humidity at a specific time and place.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdetermineweather2025video.mp4?alt=media&token=b0dc68f0-f495-4f84-81eb-e9b804dda225",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdetermineweather2025song.mp3?alt=media&token=24b9d787-ecf5-4951-9b5e-3f9be7efc183",
    lyrics: ["(Verse)",
"To determine the weather in a particular time and place,",
"You should know the temperature, that’s the measure",
"Of the degree of heat of a substance.",

"To determine the weather in a particular time and place,",
"Look for precipitation, rain, sleet, snow, hail,",
"And time period amounts.",

"To determine the weather in a particular time and place,",
"You should know the wind direction,",
"Which way is it blowing? North, South, East, or West.",

"To determine the weather in a particular time and place,",
"You should know the wind speed, the rate of motion of the air",
"In knots or nautical miles.",

"To determine the weather in a particular time and place,",
"You should know a barometer is used to measure",
"The atmospheric pressure.",

"To determine the weather in a particular time and place,",
"You should know that humidity",
"Is the amount of water vapor in the air, yeah, yeah, yeah, yeah.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Earth’s Rotation",
    slug: "earthsrotation",
    standardNumber: "4.5",
    description: "Earth and Space Systems – Earth rotates on its axis once every 24 hours, causing the cycle of day and night and making the sun, moon, and stars appear to move across the sky.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrotation.mp4?alt=media&token=a31d8de2-9598-4afe-bfcb-c3b51a18246c",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrotation.mp3?alt=media&token=9312642c-9568-452a-8cc8-634c7e5d125f",
    lyrics: ["(chorus)",
"Earth rotates around and around,",
"around and around again.",
"Earth rotates around and around,",
"around and around again.",

"(verse)",
"The Earth spins on its axis,",
"it's turning, it's turning.",
"Makes the sky look like it's moving,",
"it's turning, it's turning.",
"It makes the sun, moon, and stars ",
"look like they’re rising in the east.",
"Then, cross the sky to set in the west, eventually.",
"That's because the Earth is turning, spinning on its axis.",
"It makes a full turn every 24 hours.",
"That is the reason for our day and night, night and day.",
"That is the reason for our day and night, night and day.",

"(chorus)",
"Earth rotates around and around,",
"around and around again.",
"Earth rotates around and around,",
"around and around again.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Sun to Pluto",
    slug: "suntopluto",
    standardNumber: "4.5",
    description: "Earth and Space Systems – The solar system includes the Sun and planets from Mercury to Neptune, with details about their features, moons, and Pluto’s change in status.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsuntopluto2025video.mp4?alt=media&token=591b45c6-e25e-4893-870b-8403d0f50786",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsuntopluto2025song.mp3?alt=media&token=ad0eed59-ab71-47c3-b765-7fdb1d59a7fc",
    lyrics: ["(Chorus)",
      "We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"(Verse 1)",
"First stop is the Sun, some people call it Sol,",
"It provides energy for the life we know.",
"Next stop is Mercury, very little gravity,",
"First planet from the sun, spins very slowly.",
"Next stop,",
"Second planet from the sun, it’s Venus,",
"Hostile, thick clouds make Venus the meanest.",
"Next stop,",
"Third planet from the sun, yes, Earth,",
"It’s 70 percent water with one moon called Luna.",
"Next stop,",
"Fourth planet from the sun, it’s Mars,",
"Scientists believe it once had lakes and oceans.",
"Next stop is Jupiter, gravity will pull on you,",
"Add a hundred pounds to the weight on Jupiter.",
"(Chorus)",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"(Verse 2)",
"Next stop is Saturn, see the ring pattern,",
"Saturn has more moons than any other planet.",
"Next stop is Uranus, a planet very old,",
"22 moons, identical to Neptune.",
"Next stop is Neptune with 13 moons,",
"so far, that’s all we know of.",
"Next stop is Pluto with a new status.",
"Scientists now say Pluto is not a planet.",
"(Chorus)",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"We will start from the sun, then we’ll travel to the planets,",
"One by one, one by one.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Earth’s Revolution",
    slug: "earthsrevolution",
    standardNumber: "4.6",
    description: "Earth and Space Systems – A revolution is the Earth’s yearly orbit around the Sun, taking 365 days to complete.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fearthsrevolution.mp4?alt=media&token=49a38c8b-48fc-4c3c-92ca-463a577121dc",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fearthsrevolution2025song.mp3?alt=media&token=29c46e1a-08f3-4b3c-ac70-d64d55ec2386",
    lyrics: ["(verse)",
"A revolution is one year,",
"365 days is how long it takes",
"for the Earth to go around the Sun.",
"It takes one year, that's a revolution.",

"(chorus)",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution.",

"(verse)",
"A revolution is one year,",
"365 days is how long it takes",
"for the Earth to go around the Sun.",
"It takes one year, that's a revolution.",

"(chorus)",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution, orbit of the Earth.",
"Earth's revolution.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Moon Phases Rap",
    slug: "moonphasesrap",
    standardNumber: "4.6",
    description: "Earth and Space Systems – The moon goes through phases including new moon, crescent, quarter, gibbous, and full as it orbits Earth and reflects sunlight.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrap2025video.mp4?alt=media&token=b2c7a588-ca4a-4103-b790-c9e5b040a867",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrap2025song.mp3?alt=media&token=88173bf0-b997-4602-b9b3-671337ff8cc1",
    lyrics: ["(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"(Verse 1)",
"When the moon is in the same direction of the sun,",
"It’s called the new moon, new moon.",
"When you don’t see no light, coming from the moon,",
"It is a dark moon, called the new moon.",
"A crescent moon is in the next stage,",
"When the moon is lit a quarter of the way.",
"Less than half but more than zero.",
"This is called a crescent moon, true.",
"Now a quarter moon’s a half-moon.",
"You see, a half-moon’s a quarter moon,",
"Quarter moon’s a half-moon.",
"They call a half-moon a quarter moon, word,",
"Because it made a quarter of its turn around the earth.",
"You see half of the moon lit up,",
"And I know what you’re thinking but,",
"It’s a half-moon, called a quarter moon.",
"Half-moon’s a quarter moon,",
"Quarter moon’s a half-moon.",
"(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"(Verse 2)",
"Now, the gibbous moon is a little more full,",
"But not all the way full.",
"The lit-up part is between a full moon,",
"And a half-moon called the gibbous moon.",
"Now the full moon shines so bright.",
"You see the full moon light up the night.",
"Halfway through a circle, circle,",
"You’ll see the full moon light up the night.",
"(Chorus)",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon.",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Moon Phases Rock",
    slug: "moonphasesrock",
    standardNumber: "4.6",
    description: "Earth and Space Systems – The moon goes through phases including new moon, crescent, quarter, gibbous, and full as it orbits Earth and reflects sunlight.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmoonphasesrock2025video.mp4?alt=media&token=25932096-f065-4705-b4e8-859a6ddc48cb",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmoonphasesrock2025song.mp3?alt=media&token=526ab6eb-b5cd-4118-aedf-8ee73536aa1a",
    lyrics: ["(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"(Verse 1)",
"The moon is in the same direction of the sun,",
"It’s a new moon, a new moon, a new moon.",
"When there’s no light coming from the moon,",
"It’s a new moon, a new moon, a new moon.",
"The moon is lit a quarter of the way,",
"It’s a crescent moon, crescent moon, crescent moon.",
"The moon is lit half of the way,",
"It’s a quarter moon, quarter moon, a quarter moon.",
"The moon made a quarter of its turn around the earth,",
"It’s a quarter moon, quarter moon, a quarter moon.",
"(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"(Verse 2)",
"The next phase is between a half and a full moon,",
"Gibbous moon, gibbous moon, third quarter almost full.",
"Now the full moon shines so bright.",
"You see the full moon light up the night.",
"Halfway through a circle you’ll see the full moon",
"Light up the night, light up the night.",
"(Chorus)",
"New moon, waxing crescent, first quarter, waxing gibbous.",
"Phases of the moon, phases of the moon.",
"Full moon, waning gibbous, last quarter, waning crescent.",
"Phases of the moon, phases of the moon.",
"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "dragDrop",
    titleImage: "",
  },
  {
    title: "Tides",
    slug: "tides",
    standardNumber: "4.6",
    description: "Earth and Space Systems – The gravitational pull between Earth and the moon causes ocean tides, with high tides on both the near and far sides of Earth and low tides in between.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftides.mp4?alt=media&token=1840c974-0041-410f-9871-c37dad1647be",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftides.mp3?alt=media&token=146d3ee0-a65a-45f4-b090-66ce2c3bdcc4",
    lyrics: ["(chorus)",
"The Earth pulls the moon towards itself, towards itself.",
"The Moon pulls the earth towards itself, towards itself.",

"(verse)",
"With a gravitational pull pulling both objects",
"the side of the earth facing the moon has more force on it.",
"The moon attracts all matter on the earth, on the earth.",
"Since the earth surface is ridged, not much change on the earth.",
"But it does affect the oceans because they’re not as rigid, right!",
"So, oceans on the moon side pull to the moon causing high tides,",
"and oceans on the opposite side of the moon bulge away from the moon,",
"and that still causes high tides, on the other side.",
"Low tides come in to play when the force of the water",
"matches the pull of the moon.",
"Low tides come in to play when the force of the water",
"matches the pull of the moon.",

"(chorus)",
"The Earth pulls the moon towards itself, towards itself.",
"The Moon pulls the earth towards itself, towards itself.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "The Moon",
    slug: "themoon",
    standardNumber: "4.6",
    description: "Earth and Space Systems – The moon’s near side has bright highlands and dark lava-filled mare, the far side shows many meteor impacts, and Apollo 11 astronauts first landed there in 1969.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthemoon.mp4?alt=media&token=bf9a5f27-cc95-455c-9d07-377924d008c5",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthemoon2025song.mp3?alt=media&token=89fb4379-2ac2-48e5-a538-3f50f6140b20",
    lyrics: ["(Verse 1)",
"Now the face of the moon turned towards us,",
"We see the light, it’s called the near side.",
"Two parts to the near side I see,",
"The highlands look bright to me,",
"And there’s dark spots that look scary,",
"Dark spots called mare, called mare.",
"Mare means seas, seas mean mare,",
"But there’s no water up there.",
"The dark material filling the mare,",
"Is dried-up lava from earlier periods.",
"There is no atmosphere,",
"And almost no gravity up.",
"Neil Armstrong was first to take a step,",
"Followed by Edwin Aldrin.",
"Both came from Apollo 11,",
"July 20th, 1969.",

"(Chorus)",
"Here we go (what), let me know (what), if we can go (what),",
"Up on the blue moon.",
"I want to see it (what), see what’s there (what), I want to be there (what),",
"Up on the blue moon.",

"(Verse 2)",
"Now the side of the moon unseen from the Earth,",
"Is called the far side, far side.",
"Pictures show that there’s almost no mares,",
"On the far side, far side.",
"But you can see a lot of meteor impacts,",
"On the far side, far side.",
"So the mare is really the difference,",
"From the near side and the far side,",
"Here we go, come on baby!",

"(Chorus)",
"Here we go (what), let me know (what), if we can go (what),",
"Up on the blue moon.",
"I want to see it (what), see what’s there (what), I want to be there (what),",
"Up on the blue moon.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "The Sun",
    slug: "thesun",
    standardNumber: "4.6",
    description: "Earth and Space Systems – The sun is a medium-sized star made mostly of hydrogen and helium, holding most of the solar system’s mass and providing the energy needed for life on Earth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthesun.mp4?alt=media&token=4d69be62-6ee9-4388-95d5-6a3ecccaeb1b",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F(4.8d)%20THE%20SUN.mp3?alt=media&token=807439ac-965c-46f4-8510-e0a6d9674548",
    lyrics: ["(chorus)",
"I shine, you shine, he shine.",
"I shine, you shine, she shine.",
"I shine, you shine, they shine.",
"We shine just like the sun.",

"(verse1)",
"I shine bright like the sun and it’s so big.",
"If it were hollow, you could fit a million earths in it.",
"it’s just a middle size star and it looks small,",
"because its ninety-three million miles, away far.",
"it’s made of hydrogen, helium, metals and more.",
"Hydrogen changes to helium in its core.",
"The sun is 98% of the solar system’s mass.",
"With out the sun’s energy on earth, we wouldn’t last.",

"(chorus)",
"I shine, you shine, he shine.",
"I shine, you shine, she shine.",
"I shine, you shine, they shine.",
"We shine just like the sun.",
"I shine, you shine, he shine.",
"I shine, you shine, she shine.",
"I shine, you shine, they shine.",
"We shine just like the sun.",

"(verse2)",
"The sun’s outer layer is the photosphere.",
"It has a temperature of 11,000 degrees.",
"On the photosphere, you’ve got sunspots.",
"Sunspots are the cooler spots.",
"The next layer is chromosphere.",
"Visible only during an eclipse.",
"The outer most layer of the sun’s atmosphere",
"is the corona,",
"and during a total solar eclipse",
"you’ll see the corona.",
"Corona is bright in x-rays,",
"very large, and extremely hot.",
"Without the sun’s energy on earth, we wouldn’t last.",

"(chorus)",
"I shine, you shine, he shine.",
"I shine, you shine, she shine.",
"I shine, you shine, they shine.",
"We shine just like the sun.",
"I shine, you shine, he shine.",
"I shine, you shine, she shine.",
"I shine, you shine, they shine.",
"We shine just like the sun.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "The Earth",
    slug: "theearth",
    standardNumber: "4.6",
    description: "Earth and Space Systems – Earth spins on its tilted axis to create day, night, and seasons, is spherical with an atmosphere rich in nitrogen, and is protected by gravity and a magnetic field that causes the northern and southern lights.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheearth2025video.mp4?alt=media&token=0cdb6b57-5154-429a-b52b-c590b0a533f3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheearth.mp3?alt=media&token=31404eaf-f3d6-49e1-b561-7bb591fef75e",
    lyrics: ["(chorus)",
"We will walk around it, on this earth.",
"We will talk about it, on this earth.",
"We will be about it, on this earth.",
"We will live around it, on this earth.",

"(verse1)",
"Now the earth spins on its axis",
"making a full turn in twenty-four hours.",
"The spinning of the Earth on its axis,",
"makes the sun look like its moving through the sky.",
"The Earth’s axis is also tilted,",
"causes the changes of the four seasons.",
"In the summertime heat affects me",
"because the sun falls more directly.",
"In the wintertime snow to my ankles.",
"Light from the sun comes at glancing angles.",
"The tilt of the Earth in the summertime",
"makes longer days and shorter nights.",
"The tilt of the Earth in the wintertime",
"makes shorter days and longer nights.",
"And that’s how it goes down.",
"In winter there’s less light to heat the ground.",

"(chorus)",
"We will walk around it, on this earth.",
"We will talk about it, on this earth.",
"We will be about it, on this earth.",
"We will live around it, on this earth.",

"(verse2)",
"Now the shape of the earth is not a circle,",
"its not flat, its spherical.",
"But I don’t know if you know,",
"the shape is slightly flatter at the pole.",
"Go around the Earth at the equator,",
"you’ll make it back twenty-five thousand miles later.",
"What the Earth is composed of,",
"solid, liquid, gas, its all by mass.",
"Iron, oxygen, silicon,",
"magnesium, nickel, sulfur, titanium.",
"Now in the atmosphere most people think the air is mainly oxygen.",
"But its seventy nine percent nitrogen, nitrogen,",
"twenty percent oxygen,",
"and one percent carbon dioxide.",

"(chorus)",
"We will walk around it, on this earth.",
"We will talk about it, on this earth.",
"We will be about it, on this earth.",
"We will live around it, on this earth.",

"(verse3)",
"The earth has two major force fields,",
"gravity and magnetism.",
"Gravity is the force at a distance",
"that attracts objects of mass towards it.",
"The force of gravity on Earth",
"holds down our atmosphere,",
"oceans and everything else.",
"Earth is like one giant magnet.",
"Magnetic pole near the north pole,",
"opposite near the south pole.",
"The magnetic field attract particle charges",
"from the sun that might harm us.",
"These particles cause the air in the upper atmosphere",
"to glow.",
"Northern lights, Southern lights,",
"Northern lights and Southern lights, Let’s go",

"(chorus)",
"We will walk around it, on this earth.",
"We will talk about it, on this earth.",
"We will be about it, on this earth.",
"We will live around it, on this earth.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Ocean",
    slug: "ocean",
    standardNumber: "4.7",
    description: "Earth and Space Systems – Ocean water contains dissolved gases and solids, with temperature decreasing and pressure increasing the deeper you go.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Focean.mp4?alt=media&token=76ef06fc-3ec1-45b2-9fd5-6ba3b11e075f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Focean.mp3?alt=media&token=2fcc4646-e7c7-4164-bf87-a36c7c30f2d8",
    lyrics: ["(verse)",
"The ocean water is mixed with different gases,",
"mixed with different gases,",
"mixed with different gases.",

"The ocean water is mixed with different gases,",
"mixed with different gases,",
"mixed with different gases.",

"The ocean water is mixed with different solids,",
"different solids,",
"different solids.",

"The deeper you go in the ocean the temperature decreases,",
"the deeper you go in the ocean the temperature decreases.",
"The deeper you go in the ocean the pressure increases,",
"the deeper you go in the ocean the pressure increases.",
"The deeper you go in the ocean the temperature decreases,",
"the deeper you go in the ocean the temperature decreases.",
"The deeper you go in the ocean the pressure increases,",
"the deeper you go in the ocean the pressure increases.",

"The ocean water is mixed with different gases,",
"mixed with different gases,",
"mixed with different gases.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Watershed",
    slug: "watershed",
    standardNumber: "4.8",
    description: "Earth Resources – A watershed is land that drains water into larger bodies, and in Virginia water flows into the Chesapeake Bay, Atlantic Ocean, Albemarle Sound, and Mississippi River to the Gulf.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwatershedva2025video.mp4?alt=media&token=0a79efaa-7c77-4f51-a8e9-f03b93984c42",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fvawatershed2025song.mp3?alt=media&token=a6e52eaa-4db4-49ad-927d-03dfa1baada9",
    lyrics: ["(Chorus)",
"A watershed is an area of land that drains into a river, a lake, a bay, or an ocean.",
"A watershed is an area of land that drains into a river, a lake, a bay, or an ocean.",

"(Verse)",
"In Virginia, our water drains into the Chesapeake Bay.",
"In Virginia, our water drains into the Atlantic Ocean.",
"In Virginia, our water drains into the Albemarle Sound.",
"In Virginia, our water drains into the Mississippi River,",
"And then to the Gulf,",
"And then to the Gulf.",

"(Chorus)",
"A watershed is an area of land that drains into a river, a lake, a bay, or an ocean.",
"A watershed is an area of land that drains into a river, a lake, a bay, or an ocean.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },

];
export default topics;
